import React from 'react';
import { Box, Typography } from '@mui/material';
import backArrow from '../../imgs/BackArrow.svg';
import { useNavigate } from 'react-router-dom';

/**
 * PremiumPublicLayout
 * A consistent layout wrapper for "Premium" public/client-side pages.
 * Similar to PremiumPageLayout but DOES NOT include MainTemplate (Sidebar/Header).
 * 
 * Props:
 * - title: Screen title (e.g. "Shipping Instructions")
 * - actions: Buttons/Actions to display on the right side of the header
 * - children: Page content
 * - hideBackButton: If true, hides the back button (useful for public links where history might not exist)
 */
const PremiumPublicLayout = ({ title, actions, children, hideBackButton = false }) => {
  const navigate = useNavigate();
  return (
    <Box 
      className="no-print"
      sx={{
        backgroundColor: "#f4f6f8", 
        minHeight: "100vh", 
        padding: "40px 24px"
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        {/* Header Section */}
        <div className="d-block d-sm-flex align-items-center mb-4">
          <div className="d-flex align-items-center">
            {!hideBackButton && (
              <div
                className="light-blue-color back-bg cursor-pointer d-flex align-items-center justify-content-center"
                style={{
                  borderRadius: "12px",
                  width: "48px",
                  height: "48px",
                  marginRight: "20px",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                  transition: "all 0.2s ease-in-out",
                }}
                onClick={() => navigate(-1)}
              >
                <img src={backArrow} height="20" width="20" alt="Back" />
              </div>
            )}
            <Typography variant="h4" style={{ fontWeight: 800, color: "#1a202c", letterSpacing: "-0.5px" }}>
              {title}
            </Typography>
          </div>
          <div className="d-flex ms-auto justify-content-center mt-3 mt-sm-0 gap-3">
            {actions}
          </div>
        </div>
        
        {/* Page Content */}
        {children}
      </div>
    </Box>
  );
};

export default PremiumPublicLayout;
